import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicSite from "@/pages/PublicSite";
import ProductPage from "@/pages/ProductPage";
import SublimationPage from "@/pages/SublimationPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<PublicSite />} />
        <Route path="/products/:productId" element={<ProductPage />} />
        <Route path="/sublimation" element={<SublimationPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
